<svg class="icon" [attr.viewbox]="viewbox()" [ngClass]="['is--' + anchor()]" aria-hidden="true">
  <title>{{ title() || anchor() }}</title>
  <use [attr.xlink:href]="'/assets/dist/svg/symbol/svg/sprite.symbol.svg#'+anchor()"></use>
</svg> 